import { useEffect, useState } from 'react'
import { memo } from 'react'
import { useDrag, useDrop } from 'react-dnd'
import dndItemTypes from '../../../../constants/dndItemTypes.jsx'
import Translation from '../../../Translation/cont/Translation.jsx'
import ImageDisplayDeleteAndUpload from '../ImagesGeneral/ImageDisplayDeleteAndUpload/index.jsx'
import ImageDisplayAndDelete from '../ImagesGeneral/ImagesDisplayAndDelete.jsx'
import ImagesMovieDisplayAndUploadFieldPosition from './ImagesMovieDsplayAndUploadFieldPosition.jsx'

export const ImagesMovieDisplayAndUploadItem = memo(function ImagesMovieDisplayAndUploadItem({ 
    itemId,
    index,
    fieldName,
    image,
    movieTitle,
    isUploading,
    onUploadStart,
    onUploadEndSuccess,
    onUploadEndError,
    imageType,
    onDeleteStart,
    onResetErrorMessages,
    findItem,
    moveItem,
    changeItem,
    getHeadingTransId
}) {
    const originalIndex = findItem(itemId).index
    const [itemHeight, setItemHeight] = useState(100)
    
    useEffect(() => {
        setTimeout(() => setHeight(), 500)
        window.addEventListener('resize', setHeight);
        return () => {
            window.removeEventListener('resize', setHeight);
        
        };
    }, []);

    const setHeight = () => {
        const elementID = 'image-positioner-container-' + index
        const element = document.getElementById(elementID)
        const elementHeight = element.offsetHeight

        if(elementHeight !== 0) {
            setItemHeight(elementHeight)
        }
    }

    // An image is focusable once it is ours: a WP upload (has an attachment id), or an
    // image that already carries a focus point (TMDB picks get one from
    // buildTmdbImageSlots). A raw provider image is offered the "save to focus" upload
    // instead — provider urls rot, so a focus point on one would pin a url that can break.
    const isFocusable = (image.hasOwnProperty('id') && image.id)
        || (image.positionX !== undefined && image.positionX !== null
            && image.positionY !== undefined && image.positionY !== null)

    const [{ isDragging }, drag, preview] = useDrag(
        () => ({
          type: dndItemTypes.MOVIE_IMAGE,
          item: { itemId, originalIndex },
          collect: (monitor) => ({
            isDragging: monitor.isDragging(),
          }),
          end: (item, monitor) => {
            const { itemId: droppedId, originalIndex } = item
            const didDrop = monitor.didDrop()
            if (!didDrop) {
                moveItem(droppedId, originalIndex)
            }
          },
        }),
        [itemId, originalIndex, moveItem],
    )

    const [, drop] = useDrop(
        () => ({
          accept: dndItemTypes.MOVIE_IMAGE,
          hover({ itemId: draggedId }) {
            if (draggedId !== itemId) {
              const { index: overIndex } = findItem(itemId)
              moveItem(draggedId, overIndex)
            }
          },
        }),
        [findItem, moveItem],
    )

    return (
        <div className="images-grid-item">
            <h5 className="image-heading text-small-regular">
                <Translation id={getHeadingTransId(index)} />
            </h5>

            <div ref={(node) => preview(drop(node))} index={index}>
                <div className={'image-positioner-container gap-10'} id={'image-positioner-container-' + index}>
                    <div className="image-wrapper" ref={drag}>
                        {isFocusable ? (
                            <ImageDisplayAndDelete
                                index={index}
                                image={image}
                                imageType={imageType}
                                isDisabled={false}
                                onDeleteImage={() => onDeleteStart(itemId)}
                            />
                        ):(
                            <ImageDisplayDeleteAndUpload
                                index={index}
                                replaceUploadAt={index}
                                isDisabled={false}
                                isUploading={isUploading}
                                image={image}
                                imageType={0 === index ? "ambient" : "backgrounds"}
                                movieTitle={movieTitle}
                                onDeleteImage={() => onDeleteStart(itemId)}
                                onUploadStart={onUploadStart}
                                onUploadEndSuccess={onUploadEndSuccess}
                                onUploadEndError={onUploadEndError}
                                onResetErrorMessages={onResetErrorMessages}
                            /> 
                        )}
                    </div>
                </div>

                {isFocusable && <>
                    <p className='text-small-light'><Translation id={'y-axis'}/></p>
                    <ImagesMovieDisplayAndUploadFieldPosition
                        fieldName={fieldName + 'Y'}
                        className={'y-axis gap-10'}
                        orientation={'vertical'}
                        fieldValue={image.positionY !== undefined && image.positionY !== null && image.positionY !== '' ? image.positionY : 0}
                        setFieldValue={changeItem(index, 'positionY')}
                    />
                    <p className='text-small-light'><Translation id={'x-axis'}/></p>
                    <ImagesMovieDisplayAndUploadFieldPosition
                        fieldName={fieldName + "X"}
                        fieldValue={image.positionX !== undefined && image.positionX !== null && image.positionX !== '' ? image.positionX : 50}
                        setFieldValue={changeItem(index, 'positionX')}
                    />
                </>}
            </div>
        </div>
    )
})

export default ImagesMovieDisplayAndUploadItem